import headerNav from '../components/header/nav';

import navigate from '../components/footer/navigate.vue'
import productcard from '../components/common/productcard.vue'
import tradecard from '../components/common/tradecard.vue'
import mystep  from '../components/common/mystep.vue';
import retailfooter from '../components/footer/retailfooter.vue'
import comtradecard from '../components/common/comtradecard.vue';
import navsearch from '../components/header/navsearch.vue';
import myhead from '../components/common/headnav.vue';
import foodcom from '../components/common/foodcom.vue';
import addnav from '../components/header/addnav.vue';
import {
    Tag,
    Col,
    Icon,
    Cell,
    CellGroup,
    Swipe,
    Toast,
    SwipeItem,
    GoodsAction,
    GoodsActionButton,
    GoodsActionIcon,
    ActionSheet,
    Sku,
    Grid,
    GridItem,
    Card,
    Button,
    SwipeCell,
    Dialog,
    Tab,
    Tabs,
    Row,
    Checkbox,
    CheckboxGroup,
    SubmitBar,
    NavBar,
    Tabbar,
    TabbarItem,
    Panel,
    List,
    Step,
    Steps,
    Field,
    Sidebar,
    SidebarItem,
    Popup,
    Stepper,
    RadioGroup,
    Radio,
    Picker,
    Uploader,
    Info,
    NoticeBar,
    Form,
    Divider,
    Area,
    PullRefresh,
    AddressList,
    AddressEdit,
    PasswordInput,
    NumberKeyboard,
    Calendar,
    Search,
    Sticky,
    Switch,
    TreeSelect,
    Loading,
    DatetimePicker,
    CountDown
} from 'vant';

const components = [
    Tag,
    Col,
    Icon,
    Cell,
    CellGroup,
    Swipe,
    SwipeItem,
    GoodsAction,
    GoodsActionButton,
    GoodsActionIcon,
    ActionSheet,
    Sku,
    Card,
    Button,
    SwipeCell,
    Dialog,
    headerNav,
    myhead,
    Grid,
    GridItem,
    NoticeBar,
    Form,
    Divider,
    Area,
    Calendar,
    Search,
    Loading,
    DatetimePicker,
    Tab, Tabs, Toast, Row, Checkbox, CheckboxGroup, SubmitBar, NavBar, Tabbar, TabbarItem, navigate, Panel, List, Step, Steps, Field,
    Sidebar, SidebarItem, Popup, productcard,tradecard, Stepper, RadioGroup, Radio, Picker, Uploader, Info,TreeSelect,
    PullRefresh,AddressList,AddressEdit,PasswordInput,NumberKeyboard,Sticky,mystep,Switch,retailfooter,comtradecard,navsearch,foodcom,
    addnav,CountDown
]

export default (Vue) => {
    components.forEach(Component => {
        Vue.component(Component.name, Component)
    });
}